// src/redux/posts/publicUserPosts/publicUserPostsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchPublicUserPosts } from "./publicUserPostsActions";

const initialState = {
  posts: [],
  loading: false,
  error: null,
  hasMore: true,
  currentPage: 0,
  perPage: 10,
  sortBy: "latest",
  period: "all",
};

const publicUserPostsSlice = createSlice({
  name: "publicUserPosts",
  initialState,
  reducers: {
    resetPublicUserPosts: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Fetch start
      .addCase(fetchPublicUserPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      // Fetch success
      .addCase(fetchPublicUserPosts.fulfilled, (state, action) => {
        const newPosts = action.payload?.posts || [];

        // If first page, replace; otherwise, append
        state.posts =
          state.currentPage === 0 ? newPosts : [...state.posts, ...newPosts];

        // Update pagination flags from backend
        state.hasMore =
          action.payload?.has_more ?? newPosts.length > 0;
        state.currentPage = action.payload?.current_page ?? state.currentPage + 1;
        state.perPage = action.payload?.per_page ?? state.perPage;
        state.sortBy = action.payload?.sort_by ?? state.sortBy;
        state.period = action.payload?.period ?? state.period;

        state.loading = false;
      })

      // Fetch failure
      .addCase(fetchPublicUserPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch user posts";
      });
  },
});

export const { resetPublicUserPosts } = publicUserPostsSlice.actions;
export default publicUserPostsSlice.reducer;
